export default __webpack_public_path__ + "static/media/jackpot-modal__background.5ad30c6c.png";